import gsap from "gsap";

const tickerContent = document.querySelector(".ticker-content");

if (tickerContent) {
  const tickerWidth = tickerContent.offsetWidth;

  gsap.to(tickerContent, {
    x: +tickerWidth,
    duration: 28,
    ease: "linear",
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize((x) => parseFloat(x) % tickerWidth),
    },
  });
}
